(() => {
  let busy = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.sn-upsell-add');
    if (!button || busy) return;
    busy = true;
    const buttons = document.querySelectorAll('.sn-upsell-add');
    buttons.forEach((item) => { item.disabled = true; });
    const label = button.textContent;
    button.textContent = '…';
    let added = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(document.querySelector('#cart-icon-bubble'));
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Unavailable');
      added = true;
      if (drawer && state.sections?.['cart-drawer'] && state.sections?.['cart-icon-bubble']) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else {
        window.location.reload();
      }
    } catch (error) {
      if (added) {
        window.location.reload();
      } else {
        button.textContent = button.dataset.retry || label;
      }
    } finally {
      busy = false;
      buttons.forEach((item) => { item.disabled = false; });
    }
  });
})();
